import React from 'react';
import AppHeader from './AppHeader';
import ShiftStatusBar from './ShiftStatusBar';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <div style={styles.layout}>
      <AppHeader />
      <div style={styles.headerSpacer} />
      <ShiftStatusBar />
      <div>{children}</div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  layout: {
    minHeight: '100vh',
  },
  headerSpacer: {
    height: 72,
  },
};
